var $ = global.jQuery = global.$;

//slidea stuff
require('../third-party/jquery.label_better.min');
//require('../third-party/datedropper.min');

var _Base = require('./_Base');

/**
 * @extends Base widget
 * @class
 */
var Form_PTS = _Base.extend(
  /** @lends _Base.prototype */
  {
    init: function() {

      $(".label_better").label_better({
        position: "top",
        animationTime: 500,
        easing: "bounce",
        offset: 0 // You can add more spacing between the input and the label. This option accepts value in pixels (without the unit). The default value is 20.
      });

      //$( "#book" ).dateDropper();



      //jcf.customForms.replaceAll();

    }
  });
module.exports = Form_PTS;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/Form_PTS.js
// module id = 333
// module chunks = 1